import React, { useState, useEffect } from "react";
import useMembreAuth from "../../hooks/useMembreAuth";
import MemberCard from "../../components/MemberCard";
import { User, Lock } from "lucide-react";

export default function MembreDashboard() {

  
  const { user, loading } = useMembreAuth();

  const [lastPresence, setLastPresence] = useState(null);
  const [presenceCount, setPresenceCount] = useState(0);
  const [absenceCount, setAbsenceCount] = useState(0);
  const [presenceRate, setPresenceRate] = useState(0);
  
useEffect(() => {
    if (!user) return;
    loadPresenceHistory();
  }, [user]);
  
  if (loading) {
    return <p className="p-6 text-center">Chargement…</p>;
  }

  if (!user) {
    window.location.href = "/membre/login";
    return null;
  }

  
  function calculateLevel(points) {
    if (points >= 600) return "Elite";
    if (points >= 300) return "Gold";
    if (points >= 100) return "Silver";
    return "Bronze";
  }

  function nextLevelPoints(points) {
    if (points < 100) return 100;
    if (points < 300) return 300;
    if (points < 600) return 600;
    return 600;
  }

  const points = user?.points || 0;
  const level = calculateLevel(points);
  const next = nextLevelPoints(points);

  const percentage =
    level === "Elite"
      ? 100
      : Math.min((points / next) * 100, 100);

  
  

  async function loadPresenceHistory() {
    const token = localStorage.getItem("membreToken");

    const res = await fetch("/api/membre?action=stats", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });

    const json = await res.json();
    if (!json.success) return;

    setLastPresence(json.lastPresence);
    setPresenceCount(json.presents);
    setAbsenceCount(json.absents);
    setPresenceRate(json.rate);
  }

  function getBadge() {
    if (presenceCount >= 15) return { label: "Leader Exemplaire", color: "bg-purple-600" };
    if (presenceCount >= 8) return { label: "Membre Engagé", color: "bg-green-600" };
    return { label: "Membre Actif", color: "bg-blue-600" };
  }

  const badge = getBadge();

  
  return (
    <div className="bg-gray-100 min-h-screen pb-24">
      <div className="max-w-4xl mx-auto px-4 py-6 space-y-6">

        <h1 className="text-xl sm:text-2xl font-extrabold text-center sm:text-left">
          Tableau de bord
        </h1>

        
        <MemberCard user={user} />

        
        <div className="bg-white p-6 rounded-xl shadow space-y-4">
          <h2 className="text-lg font-bold">
            Niveau : {level}
          </h2>

          <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
            <div
              className="h-full bg-blue-600 transition-all duration-500"
              style={{ width: `${percentage}%` }}
            />
          </div>

          {level !== "Elite" && (
            <p className="text-sm text-gray-500">
              {next - points} points pour atteindre le prochain niveau
            </p>
          )}
        </div>

        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <ActionButton icon={<User size={20} />} label="Mon profil" href="/membre/profile" />
          <ActionButton icon={<Lock size={20} />} label="Mot de passe" href="/membre/change-password" />

          <button
            onClick={() => (window.location.href = "/membre/history")}
            className="sm:col-span-2 w-full bg-indigo-600 text-white py-3 rounded-xl font-semibold shadow"
          >
            Voir mon historique
          </button>
        </div>

      </div>
    </div>
  );
}



function ActionButton({ icon, label, href }) {
  return (
    <button
      onClick={() => (window.location.href = href)}
      className="w-full p-4 bg-white rounded-xl shadow flex items-center justify-center gap-3 font-semibold hover:bg-gray-100 transition"
    >
      {icon}
      {label}
    </button>
  );
}
